import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    active: Boolean,
  };

  declare activeValue: boolean;
  declare readonly hasActiveValue: boolean;

  activeValueChanged() {
    if (this.activeValue) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }
}
